/* The signal path, reorderable.

   This is the one thing on the page that explains what Echo Valley IS rather
   than what each engine does: five effects in series on a single route, in an
   order the player drags. That is also the reason to buy it, since five
   separate plug-ins can never feed each other this way.

   Draggable rather than illustrated because the plug-in's home screen is
   draggable, so the visitor performs the feature instead of reading about it.

   POINTER EVENTS, not HTML5 drag-and-drop: dragstart never fires on touch, so
   the mobile half of the audience would get a diagram they cannot move. One
   code path covers mouse, trackpad, pen and finger.

   The dragged block takes pointer-events:none while it moves, or
   elementFromPoint returns the block itself and it never finds a neighbour.

   Arrow keys reorder a focused block too. Rearranging is the only way to
   understand this section, so it cannot be mouse-only. */
(function(){
  var rack = document.querySelector('.ev-flow-rack');
  if (!rack) return;

  function items(){ return [].slice.call(rack.querySelectorAll('.ev-flow-eng')); }

  var drag = null;

  function moveTo(e){
    if (!drag) return;
    var under = document.elementFromPoint(e.clientX, e.clientY);
    var t = under && under.closest ? under.closest('.ev-flow-eng') : null;
    if (!t || t === drag || t.parentNode !== rack) return;
    var r = t.getBoundingClientRect();
    rack.insertBefore(drag, e.clientX > r.left + r.width / 2 ? t.nextSibling : t);
  }

  function stop(){
    if (!drag) return;
    drag.classList.remove('is-drag');
    rack.classList.remove('is-sorting');
    drag = null;
    document.removeEventListener('pointermove', moveTo);
    document.removeEventListener('pointerup', stop);
    document.removeEventListener('pointercancel', stop);
  }

  rack.addEventListener('pointerdown', function(e){
    var el = e.target.closest ? e.target.closest('.ev-flow-eng') : null;
    if (!el) return;
    drag = el;
    el.classList.add('is-drag');
    rack.classList.add('is-sorting');
    document.addEventListener('pointermove', moveTo);
    document.addEventListener('pointerup', stop);
    document.addEventListener('pointercancel', stop);
    e.preventDefault();
  });

  rack.addEventListener('keydown', function(e){
    var el = e.target.closest ? e.target.closest('.ev-flow-eng') : null;
    if (!el) return;
    var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
    if (!d) return;
    e.preventDefault();
    var list = items(), i = list.indexOf(el), j = i + d;
    if (j < 0 || j >= list.length) return;
    rack.insertBefore(el, d > 0 ? list[j].nextSibling : list[j]);
    el.focus();
  });
})();
